const breadCrumb = "Rendimento - TXT de Rendimento";

const routes = [
  {
    path: "/gerar-txt-de-rendimento-por-escola-e-periodo",
    name: "gerar-txt-de-rendimento-por-escola-e-periodo",
    meta: {
      //allowedPermissions: ["rendimento_turma_list"],
      requireAuth: false,
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/GerarTXTDeRendimentoPorEscolaEPeriodo/GerarTXTDeRendimentoPorEscolaEPeriodo.vue"
      ),
  },
];

export default routes;
